import { API_URL as API_URL_ENV, CDN_URL as CDN_URL_ENV } from 'react-native-dotenv';

export const API_URL = API_URL_ENV || 'http://localhost:3000/graphql'; // @TODO Load properly
export const CDN_URL = CDN_URL_ENV;
